module.exports = {
          srcSet: __webpack_public_path__ + "3dcc848f2f6556369720620277ba4d59-1263.png"+" 1263w",
          images:[ {path: __webpack_public_path__ + "3dcc848f2f6556369720620277ba4d59-1263.png",width: 1263,height: 919}],
          src: __webpack_public_path__ + "3dcc848f2f6556369720620277ba4d59-1263.png",
          toString:function(){return __webpack_public_path__ + "3dcc848f2f6556369720620277ba4d59-1263.png"},
          
          width: 1263,
          height: 919
        }